module.exports = __webpack_public_path__ + "img/swiper_3.0_1_2.0cc18eba.webp";